import React, { useState, useEffect, useRef } from "react";
import * as url from "../../../../utils/url";
import axios from "../../../../axios";
import {
  Button,
  Card,
  Row,
  Col,
} from "reactstrap";
import { FaExclamationTriangle } from "react-icons/fa";
import TextSentimentComponentOverall from "./TextSentimentComponentOverall";
import { BiRecycle } from "react-icons/bi";
import parse from "react-html-parser";
import { BsStar, BsStars, BsDownload, BsFileEarmarkPdf, BsPaperclip, BsSliders, BsChevronDown } from "react-icons/bs";
import EmptyTable from "../../../../components/EmptyTable/EmptyTable";
import MessagingResponseFullModal from "./MessagingResponseFullModal";
import { buildExportScopeBody } from "./exportResultsCsv";
import {
  LayoutHeading,
  LayoutData,
} from "../../../weekly-wins/TableLayoutComponents";
import { LayoutRow } from "../../../../components/TableComponents/RowBordered/RowBordered";
import ColumnResizeHandle from "../ColumnResizeHandle";
import useColumnResize from "../../../../hooks/useColumnResize";
import {
  isOffPlatformShare,
  SENTIMENTS_COLOR_MAP2,
  SENTIMENTS_TYPO_MAP,
  SENTIMENTS_TYPO_MAP2,
  showYou,
} from "../../data";
import ListEmptyDash from "../ListEmptyDash";
import { isMobile } from "../../../../utils/deviceInfo";
import { profilePicValidityCheck } from "../../../../utils/constants";
import moment from "moment";
import SeeMoreWrapper from "../../../../components/Shared/SeeMoreWrapper";
import "./resultsComponents.css";
// import { useNavigate } from "react-router-dom";

// const navigate = useNavigate();
import { withRouter } from "react-router-dom";
import SpinnerLoader from "../../../../components/UI/SpinnerLoader/SpinnerLoader";



import { BiUpArrowAlt, BiDownArrowAlt, BiHide } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { orderBy } from "lodash";

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import {
  normalizeMessageText,
  normalizeSingleLine,
} from "../../../../utils/normalizeText";
import { stripSmsBoilerplate } from "../../../../utils/stripSmsBoilerplate";

const parseFileNameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition || typeof contentDisposition !== "string") return "";

  try {
    const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ""));
    }

    const quotedMatch = contentDisposition.match(/filename\s*=\s*"([^"]+)"/i);
    if (quotedMatch && quotedMatch[1]) {
      return quotedMatch[1].trim();
    }

    const plainMatch = contentDisposition.match(/filename\s*=\s*([^;]+)/i);
    if (plainMatch && plainMatch[1]) {
      return plainMatch[1].trim().replace(/^"|"$/g, "");
    }
  } catch (err) {
    return "";
  }

  return "";
};

const getFileNameFromUrl = (fileUrl) => {
  if (!fileUrl || typeof fileUrl !== "string") return "";

  try {
    const baseUrl = typeof window !== "undefined" && window.location ? window.location.origin : "http://localhost";
    const parsedUrl = new URL(fileUrl, baseUrl);

    // S3 signed URLs may carry the real filename in response-content-disposition.
    // Prefer that value because the path/key can be generic or encoded.
    const disposition =
      parsedUrl.searchParams.get("response-content-disposition") ||
      parsedUrl.searchParams.get("ResponseContentDisposition") ||
      "";
    const dispositionFileName = parseFileNameFromContentDisposition(disposition);
    if (dispositionFileName) return dispositionFileName;

    const cleanPath = parsedUrl.pathname || "";
    const parts = cleanPath.split("/");
    return decodeURIComponent(parts[parts.length - 1] || "");
  } catch (err) {
    try {
      const cleanUrl = fileUrl.split("?")[0].split("#")[0];
      const parts = cleanUrl.split("/");
      return decodeURIComponent(parts[parts.length - 1] || "");
    } catch (fallbackErr) {
      return "";
    }
  }
};

const getFileExtension = (fileNameOrUrl) => {
  const rawValue = fileNameOrUrl ? String(fileNameOrUrl) : "";
  const value =
    rawValue.indexOf("?") !== -1 || rawValue.indexOf("/") !== -1
      ? getFileNameFromUrl(rawValue) || rawValue
      : rawValue;
  const cleanValue = value.split("?")[0].split("#")[0];
  const parts = cleanValue.split(".");
  if (parts.length < 2) return "";
  return parts[parts.length - 1].toLowerCase();
};

const formatFileSize = (size) => {
  const bytes = Number(size);
  if (!bytes || Number.isNaN(bytes)) return "";
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
};

const inferAttachmentKind = (attachment) => {
  if (!attachment) return "file";

  const mimeType = attachment.mimeType ? String(attachment.mimeType).toLowerCase() : "";
  const playbackContentType = attachment.playbackContentType
    ? String(attachment.playbackContentType).toLowerCase()
    : "";
  const extension =
    getFileExtension(attachment.fileName) ||
    getFileExtension(attachment.filename) ||
    getFileExtension(attachment.name) ||
    getFileExtension(attachment.originalName) ||
    getFileExtension(attachment.originalFilename) ||
    getFileExtension(attachment.url) ||
    getFileExtension(attachment.fileUrl) ||
    getFileExtension(attachment.mediaUrl) ||
    getFileExtension(attachment.attachmentUrl) ||
    getFileExtension(attachment.signedUrl) ||
    getFileExtension(attachment.playableUrl) ||
    getFileExtension(attachment.browserPlayableUrl);

  if (
    mimeType.indexOf("image/") === 0 ||
    ["jpg", "jpeg", "png", "gif", "webp", "heic", "heif", "bmp"].indexOf(extension) !== -1
  ) {
    return "image";
  }

  if (mimeType.indexOf("pdf") !== -1 || extension === "pdf") {
    return "pdf";
  }

  if (
    mimeType.indexOf("audio/") === 0 ||
    playbackContentType.indexOf("audio/") === 0 ||
    ["mp3", "mpeg", "wav", "wave", "m4a", "aac", "ogg", "oga", "opus", "webm", "amr", "awb", "flac"].indexOf(extension) !== -1
  ) {
    return "audio";
  }

  if (
    mimeType.indexOf("video/") === 0 ||
    playbackContentType.indexOf("video/") === 0 ||
    ["mp4", "mov", "m4v", "webm", "avi", "wmv", "mkv", "3gp", "3g2"].indexOf(extension) !== -1
  ) {
    return "video";
  }

  return "file";
};

const normalizeAttachment = (rawAttachment) => {
  if (!rawAttachment) return null;

  if (typeof rawAttachment === "string") {
    const urlValue = rawAttachment;
    const fileNameValue = getFileNameFromUrl(urlValue);
    const normalizedStringAttachment = {
      url: urlValue,
      fileName: fileNameValue,
      mimeType: "",
      fileSize: null,
      playableUrl: "",
      browserPlayableUrl: "",
      playbackContentType: "",
    };
    return {
      ...normalizedStringAttachment,
      kind: inferAttachmentKind(normalizedStringAttachment),
    };
  }

  if (typeof rawAttachment !== "object") return null;

  const urlValue =
    rawAttachment.url ||
    rawAttachment.fileUrl ||
    rawAttachment.mediaUrl ||
    rawAttachment.attachmentUrl ||
    rawAttachment.signedUrl ||
    rawAttachment.secureUrl ||
    rawAttachment.location ||
    rawAttachment.href ||
    "";

  const playableUrlValue =
    rawAttachment.playableUrl ||
    rawAttachment.browserPlayableUrl ||
    rawAttachment.playbackUrl ||
    rawAttachment.playbackMediaUrl ||
    rawAttachment.transcodedUrl ||
    rawAttachment.convertedUrl ||
    rawAttachment.mp3Url ||
    rawAttachment.m4aUrl ||
    "";

  const fileNameValue =
    rawAttachment.fileName ||
    rawAttachment.filename ||
    rawAttachment.name ||
    rawAttachment.originalName ||
    rawAttachment.originalFilename ||
    rawAttachment.key ||
    getFileNameFromUrl(urlValue) ||
    getFileNameFromUrl(playableUrlValue) ||
    "Attachment";

  const normalizedObjectAttachment = {
    url: urlValue,
    fileName: fileNameValue,
    mimeType:
      rawAttachment.mimeType ||
      rawAttachment.contentType ||
      rawAttachment.mediaContentType ||
      rawAttachment.type ||
      "",
    fileSize:
      rawAttachment.fileSize ||
      rawAttachment.size ||
      rawAttachment.bytes ||
      rawAttachment.contentLength ||
      null,
    playableUrl: playableUrlValue,
    browserPlayableUrl: rawAttachment.browserPlayableUrl || playableUrlValue,
    playbackContentType:
      rawAttachment.playbackContentType ||
      rawAttachment.playableContentType ||
      rawAttachment.convertedContentType ||
      rawAttachment.transcodedContentType ||
      "",
  };

  return {
    ...normalizedObjectAttachment,
    kind: inferAttachmentKind(normalizedObjectAttachment),
  };
};

const appendAttachmentCandidates = (candidates, value) => {
  if (!value) return;
  if (Array.isArray(value)) {
    value.forEach((item) => appendAttachmentCandidates(candidates, item));
    return;
  }
  candidates.push(value);
};

const getFirstMessagingAttachment = (result) => {
  if (!result) return null;

  const messagingResponse = result.messagingResponse || {};
  const candidates = [];

  appendAttachmentCandidates(candidates, messagingResponse.attachments);
  appendAttachmentCandidates(candidates, messagingResponse.attachment);
  appendAttachmentCandidates(candidates, messagingResponse.media);
  appendAttachmentCandidates(candidates, messagingResponse.mediaFile);
  appendAttachmentCandidates(candidates, messagingResponse.mediaFiles);
  appendAttachmentCandidates(candidates, messagingResponse.files);
  appendAttachmentCandidates(candidates, messagingResponse.file);
  appendAttachmentCandidates(candidates, messagingResponse.mediaUrl);
  appendAttachmentCandidates(candidates, messagingResponse.mediaUrls);
  appendAttachmentCandidates(candidates, messagingResponse.fileUrl);
  appendAttachmentCandidates(candidates, messagingResponse.attachmentUrl);
  appendAttachmentCandidates(candidates, messagingResponse.signedUrl);

  appendAttachmentCandidates(candidates, result.attachments);
  appendAttachmentCandidates(candidates, result.attachment);
  appendAttachmentCandidates(candidates, result.media);
  appendAttachmentCandidates(candidates, result.mediaFile);
  appendAttachmentCandidates(candidates, result.mediaFiles);
  appendAttachmentCandidates(candidates, result.files);
  appendAttachmentCandidates(candidates, result.file);
  appendAttachmentCandidates(candidates, result.mediaUrl);
  appendAttachmentCandidates(candidates, result.mediaUrls);
  appendAttachmentCandidates(candidates, result.fileUrl);
  appendAttachmentCandidates(candidates, result.attachmentUrl);
  appendAttachmentCandidates(candidates, result.signedUrl);

  for (let i = 0; i < candidates.length; i++) {
    const normalized = normalizeAttachment(candidates[i]);
    if (normalized && (normalized.url || normalized.fileName)) {
      return normalized;
    }
  }

  return null;
};

const renderAttachmentIndicator = (rawAttachment) => {
  const attachment = normalizeAttachment(rawAttachment);

  if (!attachment) {
    return <span style={{ color: "#6b7280", fontSize: "12px" }}>-</span>;
  }

  if (attachment.kind === "image" && attachment.url) {
    return (
      <span
        title={attachment.fileName || "Image attachment"}
        style={{
          width: "42px",
          height: "42px",
          borderRadius: "8px",
          overflow: "hidden",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #e2e8f0",
          backgroundColor: "#f8fafc",
        }}
      >
        <img
          src={attachment.url}
          alt={attachment.fileName || "Attachment"}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          onError={(event) => {
            event.currentTarget.style.display = "none";
          }}
        />
      </span>
    );
  }

  const isPdf = attachment.kind === "pdf";
  const isAudio = attachment.kind === "audio";
  const isVideo = attachment.kind === "video";
  const extension = getFileExtension(attachment.fileName || attachment.url || attachment.playableUrl);
  const label = isPdf
    ? "PDF"
    : isAudio
      ? "Audio"
      : isVideo
        ? "Video"
        : (extension || "File").toUpperCase();

  return (
    <span
      title={attachment.fileName || "File attachment"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        maxWidth: "100%",
        border: "1px solid #e2e8f0",
        borderRadius: "999px",
        backgroundColor: "#f8fafc",
        padding: "4px 9px",
        color: "#334155",
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      {isPdf ? <BsFileEarmarkPdf color="#ff4500" /> : <BsPaperclip color="#64748b" />}
      {label}
    </span>
  );
};

function MessagingTriviaResultsResponses({
  trivia,
  user,
  userSubmissions,
  history: routerHistory,
  setNeedsAttentionSortTrigger,
  needsAttentionSortTrigger,
  isFilterLoading,
  onOpenFilters,
  ...props
}) {
  const [originalResponsesData, setOriginalResponsesData] = useState([]);
  const [responsesData, setResponsesData] = useState([]);
  const [fullTextModal, setFullTextModal] = useState(null);
  // Mobile By User list: which rows are expanded to show the response text.
  const [expandedRows, setExpandedRows] = useState({});
  const [sortParams, setSortParams] = useState({ sortBy: "date", sortOrder: "desc" });
  const [dropdownOpenCol, setDropdownOpenCol] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);

  // In-session resizable Response column (desktop only). State resets on
  // unmount (sub-tab switch / reload), which is the intended behaviour.
  const {
    columnWidths,
    getWidth,
    startResize,
    resetColumn,
  } = useColumnResize();
  const responseWidthOverride = columnWidths["response"];
  const hasSortedNeedsAttention = useRef(false);

  // Dropdown logic for column menu
  const toggleCol = (col) => {
    setDropdownOpenCol(dropdownOpenCol === col ? null : col);
  };

  const renderDDtab = (col, label) => {
    const isSortedByThisCol = sortParams.sortBy === col;
    const nextSortOrder = isSortedByThisCol && sortParams.sortOrder === "asc" ? "desc" : "asc";

    return (
      <Dropdown isOpen={dropdownOpenCol === col} toggle={() => toggleCol(col)} direction="down">
        <DropdownToggle
          size="sm"
          tag={"span"}
          className="action-table-col-overlap"
          style={{ cursor: "pointer", padding: 0, marginLeft: 6 }}
        >
          <span className="TriviaEditViewListUI_leftContainer_singleQuestion_threedots_wrapper">
            <BsThreeDotsVertical />
          </span>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => { setSortParams({ sortBy: col, sortOrder: nextSortOrder }); setDropdownOpenCol(null); }}>
            {isSortedByThisCol && (nextSortOrder === 'asc' ?
              <BiUpArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} /> :
              <BiDownArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} />
            )}
            {isSortedByThisCol && ' '}
            Sort
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  const handleFetchUsers = async () => {
    axios
      .get(url.getMessagingResponses(trivia._id))
      .then(({ data }) => {
        console.log("48 --- ", data);
        // BE quirk (email-sent messaging trivvys): the backend creates
        // TWO records per user — a placeholder with no `messagingResponse`
        // but the correct `createdOn` (= true send time), and a second
        // record with the actual response text whose `createdOn` is the
        // response timestamp (NOT the send time). We hide the placeholder
        // row to avoid the duplicate "No response" UI, but first salvage
        // its `createdOn` and use it as the displayed sent date for the
        // response row, keyed by userId. SMS sends use a single record
        // so this map is empty for them and the existing fallback applies.
        const placeholderSentByUser = {};
        data.data.forEach((res) => {
          const hasResponseText =
            res.messagingResponse && res.messagingResponse.text;
          if (hasResponseText) return;
          const userKey = res.userId && res.userId._id ? res.userId._id : null;
          if (!userKey || !res.createdOn) return;
          if (
            !placeholderSentByUser[userKey] ||
            new Date(res.createdOn) < new Date(placeholderSentByUser[userKey])
          ) {
            placeholderSentByUser[userKey] = res.createdOn;
          }
        });

        const dataFormatted = data.data
          .filter((res) => res.messagingResponse && res.messagingResponse.text)
          .map((res) => {
            const userKey =
              res.userId && res.userId._id ? res.userId._id : null;
            const salvagedSentDate =
              userKey && placeholderSentByUser[userKey]
                ? placeholderSentByUser[userKey]
                : null;
            // NOTE: in the legacy render, `result.date` shows under the
            // "Sent Date" header and `result.sentDate` shows under
            // "Response Date" (field names are intentionally inverted).
            // So the salvaged email-send timestamp goes into `date`.
            const defaultDate = res.dateTrivvySent
              ? res.dateTrivvySent
              : res.messagingResponse
                ? res.messagingResponse.respondedDate
                : res.createdOn;
            return {
              user: res.userId ? res.userId : res.userData,
              response: stripSmsBoilerplate(res.messagingResponse.text),
              attachment: getFirstMessagingAttachment(res),
              date: isOffPlatformShare(res)
                ? null
                : salvagedSentDate || defaultDate,
              sentimentData:
                res.sentimentsScore && res.sentimentsScore.sentiment
                  ? res.sentimentsScore
                  : null,
              sentDate: res.isSubmittedDate || '',
              needsAttention: res.needsAttention,
              ...res,
            };
          });

        setOriginalResponsesData(dataFormatted);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  useEffect(() => {
    handleFetchUsers();
  }, []);


  useEffect(() => {
    if (
      userSubmissions &&
      userSubmissions.length === 1 &&
      userSubmissions[0] === "filter"
    ) {
      handleFetchUsers();
    } else if (userSubmissions && userSubmissions.users) {
      const dataFormatted = userSubmissions.users
        .filter((res) => res.messagingResponse)
        .map((res) => ({
        ...res,
        // bug826: `_id` is needed so the CSV export can scope to exactly the
        // filtered rows on screen. The `...res` spread above already carries it;
        // kept explicit so the export contract can't silently break if that
        // spread ever changes.
        _id: res._id,
        user: res.userId,
        response: stripSmsBoilerplate(res.messagingResponse.text) || "No response",
        attachment: getFirstMessagingAttachment(res),
        date: isOffPlatformShare(res)
          ? null
          : res.dateTrivvySent ? res.dateTrivvySent : res.messagingResponse
          ? res.messagingResponse.respondedDate
          : res.createdOn,
        sentDate: res.isSubmittedDate || '',
        sentimentData:
          res.sentimentsScore && res.sentimentsScore.sentiment
            ? res.sentimentsScore
            : null,
        needsAttention: res.needsAttention,
      }));
      setOriginalResponsesData(dataFormatted);
    }
  }, [userSubmissions]);

      // Parse URL query params for initial sorting on mount
    useEffect(() => {
      const searchParams = new URLSearchParams(props.location.search);
      const sortBy = searchParams.get('sortBy');
      const sortOrder = searchParams.get('sortOrder');
      if ((!hasSortedNeedsAttention.current || needsAttentionSortTrigger) && sortBy === 'needsAttention' && sortOrder && responsesData && responsesData.length > 0) {
        let list = [...responsesData];
        list = orderBy(list, (itm) => itm.needsAttention ? 1 : 0, [sortOrder]);
        setResponsesData(list);
        hasSortedNeedsAttention.current = true;
        setNeedsAttentionSortTrigger(false);
      }
    }, [responsesData, props.location.search, needsAttentionSortTrigger]);

  // Sorting logic
  useEffect(() => {
    let list = [...originalResponsesData];
    const { sortBy, sortOrder } = sortParams;

    if (!sortBy || !sortOrder) {
      setResponsesData(list);
      return;
    }

    switch (sortBy) {
      case "date":
        list = orderBy(list, (itm) => itm.date ? moment(itm.date).valueOf() : 0, [sortOrder]);
        break;
      case "sentDate":
        list = orderBy(list, (itm) => itm.sentDate ? moment(itm.sentDate).valueOf() : 0, [sortOrder]);
        break;
      case "user":
        list = orderBy(list, (itm) => getDisplayedUserName(itm.user, itm.isAnonymous).toLowerCase(), [sortOrder]);
        break;
      case "sentimentData":
        list = orderBy(list, (itm) => {
          if (!itm.sentimentData || !itm.sentimentData.sentiment) return "";
          return SENTIMENTS_TYPO_MAP2[itm.sentimentData.sentiment] || "";
        }, [sortOrder]);
        break;
      case "response":
        list = orderBy(list, (itm) => (itm.response || "").toLowerCase(), [sortOrder]);
        break;
      case "needsAttention":
        list = orderBy(list, (itm) => itm.needsAttention ? 1 : 0, [sortOrder]);
        break;
      case "conversationMessageCount":
        list = orderBy(list, (itm) => itm.conversationMessageCount == null ? 0 : itm.conversationMessageCount, [sortOrder]);
        break;
      default:
        break;
    }
    setResponsesData(list);
  }, [originalResponsesData, sortParams]);

  const sortComponent = (key) => {
    if (
      sortParams.sortBy === key &&
      sortParams.sortOrder === "asc"
    ) {
      return <BiDownArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} />;
    } else if (sortParams.sortBy === key && sortParams.sortOrder === "desc") {
      return <BiUpArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} />;
    } else {
      return null;
    }
  };

  let isDataExists = responsesData && responsesData.length > 0;

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const getDisplayedUserName = (user, isAnonymous) => {
    if (!user || isAnonymous) return "Anonymous user";
    // bug820 + QA union: keep the consolidated name/anonymity logic, but clean
    // firstName/lastName through normalizeSingleLine (QA's text-normalization) so
    // the displayed AND sorted name strips HTML/entities/replacement chars.
    const name = (normalizeSingleLine(user.firstName) + " " + normalizeSingleLine(user.lastName)).trim();
    if (name) return name;
    return user.email || user.mobileNumber || user.employeeId || user.identification || "";
  };

  const openChatHistoryModal = (result) => {
    const allResult = {
      ...result,
      comingFromNeedsAttention: true,
    };
    setFullTextModal(allResult);
  };

  if (isFilterLoading) {
    return (
      <div style={{ marginTop: "48px", minHeight: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <SpinnerLoader />
      </div>
    );
  }

  const handleExportCSV = () => {
    setExportLoading(true);
    // bug826: scope the export to exactly the rows on screen. Messaging has a
    // single filter source — the sidebar filter that populates
    // `userSubmissions.users`. When it is active we POST the visible submission
    // ids; otherwise we send no scope and the BE keeps its full-export path.
    // The CSV is still built client-side below from the returned rows.
    const isFilterActive = !!(userSubmissions && userSubmissions.users);
    const scopeBody = buildExportScopeBody(responsesData, isFilterActive);
    axios
      .post(url.exportMessagingResponsesCSV(trivia._id), scopeBody)
      .then(function (response) {
        var csvData = response && response.data && response.data.data;
        if (!csvData) {
          setExportLoading(false);
          return;
        }

        var csvRows = [];
        csvRows.push(csvData.headers.join(","));

        if (csvData.rows && csvData.rows.length > 0) {
          for (var i = 0; i < csvData.rows.length; i++) {
            var row = csvData.rows[i].map(function (cell, colIndex) {
              // Columns 1 (Sent Date) and 2 (Response Date) are raw ISO dates — format in browser timezone
              if ((colIndex === 1 || colIndex === 2) && cell) {
                var cellStr = moment(cell).format("lll");
              } else {
                var cellStr = cell === null || cell === undefined ? "" : String(cell);
              }
              if (!cellStr && (colIndex === 1)) cellStr = "-";
              if (!cellStr && (colIndex === 2)) cellStr = "-";
              if (cellStr.indexOf(",") !== -1 || cellStr.indexOf('"') !== -1 || cellStr.indexOf("\n") !== -1) {
                cellStr = '"' + cellStr.replace(/"/g, '""') + '"';
              }
              return cellStr;
            });
            csvRows.push(row.join(","));
          }
        }

        var csvString = csvRows.join("\n");
        var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        var downloadUrl = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute(
          "download",
          (trivia.name || "Messaging Trivia") + " - " + moment().format("MM/DD/YYYY") + ".csv"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);
        setExportLoading(false);
      })
      .catch(function (err) {
        console.log("Error exporting CSV:", err);
        setExportLoading(false);
      });
  };
  if (trivia && trivia.isOneWay === true) {
    return (
      <div className="text-center mt-5">
        <p>Results are not available for 1-way messages.</p>
      </div>
    );
  }

  if (isFilterLoading && !isMobile) {
    return (
      <div style={{ marginTop: "48px", minHeight: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <SpinnerLoader />
      </div>
    );
  }

  return (
    <div style={{ position: "relative" }}>
      {isFilterLoading && (
        <div className="insights-filter-overlay">
          <SpinnerLoader />
        </div>
      )}
      <Card className="p-3 message-results-card">
        <h5 className="messaging-results-header byuser-message-heading">
          <strong>
            {trivia.name ? normalizeSingleLine(trivia.name) : "No title"}:
          </strong>{" "}
          {normalizeMessageText(trivia.messagingSubject)}
        </h5>
      </Card>

      {/* Mobile: Filter trigger (left) + Download (right), opening the same
          bottom sheet / CSV export as desktop. */}
      {isMobile && (
        <div className="msg-byuser-actions">
          {onOpenFilters && (
            <button
              type="button"
              className="results-filter-trigger"
              onClick={onOpenFilters}
            >
              <BsSliders className="results-filter-trigger-icon" />
              Filter
            </button>
          )}
          <button
            type="button"
            className="msg-byuser-download"
            onClick={handleExportCSV}
            disabled={exportLoading}
          >
            <BsDownload size={15} />
            {exportLoading ? "Exporting..." : "Download"}
          </button>
        </div>
      )}

      {fullTextModal && (
        <MessagingResponseFullModal
          data={fullTextModal}
          onClose={() => setFullTextModal(null)}
          user={user}
          adminAId={trivia && trivia.createdBy && (trivia.createdBy._id || trivia.createdBy)}
        />
      )}

      <div className="mt-4">
        <div>
          {responsesData.length > 0 ? (
            <>
              {isMobile && (
                <div className="msg-byuser-mobile">
                  <div className="msg-byuser-count">
                    {responsesData.length}{" "}
                    {responsesData.length === 1 ? "RESPONSE" : "RESPONSES"}
                  </div>
                  <div className="msg-byuser-table">
                    <div className="msg-byuser-head">
                      <span className="mbu-c-user">USER</span>
                      <span className="mbu-c-sent">SENTIMENT</span>
                      <span className="mbu-c-att">
                        <FaExclamationTriangle size={12} />
                      </span>
                      <span className="mbu-c-date">DATE</span>
                    </div>
                    {responsesData.map((result, i) => {
                      const sent =
                        result.sentimentData && result.sentimentData.sentiment
                          ? result.sentimentData.sentiment
                          : "NEUTRAL";
                      const label =
                        result.sentimentData && result.sentimentData.sentiment
                          ? SENTIMENTS_TYPO_MAP2[result.sentimentData.sentiment]
                          : "N/A";
                      const dt = result.sentDate || result.createdOn;
                      const isOpen = !!expandedRows[i];
                      return (
                        <div className="msg-byuser-rowwrap" key={i}>
                          <div
                            className="msg-byuser-row"
                            onClick={() => openChatHistoryModal(result)}
                          >
                            <span className="mbu-c-user mbu-user">
                              {/* Chevron toggles the inline response; it stops
                                  propagation so it doesn't also open the modal
                                  (the rest of the row opens the modal). */}
                              <span
                                className="mbu-chev-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setExpandedRows((prev) => ({
                                    ...prev,
                                    [i]: !prev[i],
                                  }));
                                }}
                              >
                                <BsChevronDown
                                  className={`mbu-chev ${isOpen ? "open" : ""}`}
                                  size={12}
                                />
                              </span>
                              <span className="mbu-name">
                                {result.user
                                  ? result.user.firstName
                                    ? result.user.firstName
                                    : result.user.email || "N/A"
                                  : "N/A"}
                              </span>
                            </span>
                            <span className={`mbu-c-sent mbu-sent mbu-sent-${sent}`}>
                              <span className="mbu-dot" />
                              {label}
                            </span>
                            <span className="mbu-c-att">
                              {result.needsAttention ? (
                                <FaExclamationTriangle className="mbu-warn" size={15} />
                              ) : (
                                <span className="mbu-dash">—</span>
                              )}
                            </span>
                            <span className="mbu-c-date">
                              {dt ? moment(dt).format("MMM D") : ""}
                            </span>
                          </div>
                          {isOpen && (
                            <div className="msg-byuser-detail">
                              <div>{result.response ? result.response : "No response"}</div>
                              {(result.attachment || getFirstMessagingAttachment(result)) && (
                                <div style={{ marginTop: "8px" }}>
                                  {renderAttachmentIndicator(result.attachment || getFirstMessagingAttachment(result))}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {!isMobile && (
              <>
              <div className="d-flex justify-content-start mb-3">
                <button
                  className="btn messages-export trivia-action-button-main btn-sm"
                  onClick={handleExportCSV}
                  disabled={exportLoading}
                >
                  <span className="export-btn">
                    {exportLoading ? "Exporting..." : "Export CSV"} <BsDownload size={13} />
                  </span>
                </button>
              </div>
              {/* Single unified scroll container so every cell in a row
                  shares the same natural row height (tallest cell sets
                  it). This avoids the row drift you get when User and
                  data columns each render in their own scroll wrapper
                  and their row heights diverge. Sticky header + internal
                  vertical scroll still work as intended. */}
              {/* bug107: keep .trivvy-messages-table-scroll on the wrapper so the
                  wide table still scrolls horizontally on mobile (it forces
                  min-width:900px on the inner rows under @media max-width:767px). */}
              <div className={`actions-table-div results-invidual-table p0 trivvyUserResTable trivvy-messages-table-scroll`}>
                <div
                  className="trivvyUserResTable-data-scroll-right"
                  style={{
                    // Desktop: allow horizontal scroll so a widened Response
                    // column scrolls instead of crushing sibling columns.
                    // Mobile keeps the prior hidden behaviour (no resize there).
                    overflowX: isMobile ? "hidden" : "auto",
                    maxHeight: "calc(75vh - 220px)",
                  }}
                >
                  <div className="trivvyUserResTable-sticky-header">
                    <LayoutRow
                      className="mobileNoheightActionTable"
                      style={{
                        flexWrap: "nowrap",
                        backgroundColor:
                          responsesData && responsesData.length > 0
                            ? ""
                            : "#8080802b",
                      }}
                    >
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          User {renderDDtab("user", "User")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Sent Date {renderDDtab("sentDate", "Sent Date")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Response Date {renderDDtab("date", "Response Date")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                        overrideWidth={responseWidthOverride}
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Response {renderDDtab("response", "Response")}
                        </span>
                        <ColumnResizeHandle
                          columnKey="response"
                          currentWidth={getWidth("response", 2 * 122)}
                          startResize={startResize}
                          resetColumn={resetColumn}
                        />
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Attachment
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Sentiment {renderDDtab("sentimentData", "Sentiment")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Needs Attention {renderDDtab("needsAttention", "Needs Attention")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Message History {renderDDtab("conversationMessageCount", "Message History")}
                        </span>
                      </LayoutHeading>
                    </LayoutRow>
                  </div>
                  {responsesData.map((result, i) => (
                    <LayoutRow
                      key={`row-${i}`}
                      className={`pl-tasks-row cursor-pointer`}
                      style={{ margin: 0, flexWrap: "nowrap" }}
                      onClick={() => openChatHistoryModal(result)}
                    >
                      <LayoutData
                        colWidth={2}
                        className={"border-gray-thin"}
                      >
                        {result.user && !result.isAnonymous ? (
                          <span
                            className="trivia_table_text_wrapper"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (
                                result &&
                                result.user &&
                                result.user._id &&
                                routerHistory &&
                                routerHistory.push
                              ) {
                                routerHistory.push(
                                  `/home/${result.organizationId}/profile/${result.user._id}`
                                );
                              }
                            }}
                          >
                            {profilePicValidityCheck(
                              result.user.profilePic
                            ) ? (
                              <img
                                src={result.user.profilePic}
                                height="35px"
                                width="35px"
                                style={{ borderRadius: "50%" }}
                              />
                            ) : (
                              <span
                                className="spotlightUserInitials"
                                data-letters={getInitials(result.user)}
                              ></span>
                            )}{" "}
                            {getDisplayedUserName(result.user, result.isAnonymous)}
                          </span>
                        ) : (
                          <span className="trivia_table_text_wrapper">
                            <span
                              className="spotlightUserInitials"
                              data-letters={"AU"}
                            ></span>
                            Anonymous user{" "}
                            {showYou(user.profile, result) ? "(You)" : ""}
                          </span>
                        )}
                      </LayoutData>
                      <LayoutData colWidth={2}>
                        <span className={"trivia_table_text_wrapper"}>
                          {result.date ? moment(result.date).format("lll") : <ListEmptyDash />}{" "}
                        </span>
                      </LayoutData>
                      <LayoutData colWidth={2}>
                        <span className={"trivia_table_text_wrapper"}>
                          {result.sentDate ? moment(result.sentDate).format("lll") : "-"}
                        </span>
                      </LayoutData>

                      <LayoutData
                        colWidth={2}
                        overrideWidth={responseWidthOverride}
                        customStyle={{
                          ...(result.sentimentData && {
                            backgroundColor:
                              SENTIMENTS_COLOR_MAP2[
                                result.sentimentData.sentiment
                              ],
                          }),
                        }}
                      >
                        <div style={{fontSize: '12px'}}>
                          <SeeMoreWrapper
                            text={result.response}
                            limit={80}
                            openModal={() => {
                              setFullTextModal(result);
                            }}
                          />
                        </div>
                      </LayoutData>

                      <LayoutData
                        colWidth={2}
                        customStyle={{ alignItems: "center", justifyContent: "center" }}
                      >
                        {renderAttachmentIndicator(result.attachment || getFirstMessagingAttachment(result))}
                      </LayoutData>

                      <LayoutData
                        colWidth={2}
                        customStyle={{
                          ...(result.sentimentData && {
                            backgroundColor:
                              SENTIMENTS_COLOR_MAP2[
                                result.sentimentData.sentiment
                              ],
                          }),
                        }}
                      >
                        <span className={"trivia_table_text_wrapper"}>
                          {result.sentimentData ? (
                            <div>
                              {
                                SENTIMENTS_TYPO_MAP2[
                                  result.sentimentData.sentiment
                                ]
                              }
                            </div>
                          ) : (
                            "N/A"
                          )}
                        </span>
                      </LayoutData>

                      <LayoutData
                        colWidth={2}
                        customStyle={{ alignItems: "center" }}
                      >
                        <div>
                          {result.needsAttention ? (
                            <FaExclamationTriangle
                              color="goldenrod"
                              size="1.8em"
                            />
                          ) : (
                            "-"
                          )}
                        </div>
                      </LayoutData>

                      <LayoutData
                        colWidth={2}
                        customStyle={{ alignItems: "center" }}
                      >
                        <span style={{fontSize: '12px'}}>{result.conversationMessageCount == 0 ? 1 : result.conversationMessageCount}</span>
                      </LayoutData>
                    </LayoutRow>
                  ))}
                </div>
              </div>
              </>
              )}
            </>
          ) : (
            <div className="d-flex justify-content-center">
              <EmptyTable
                title={"No responses found"}
                subtitle={"No user has submitted any responses yet."}
              />
            </div>
          )}
        </div >
      </div >
    </div >
  );
}

export default withRouter(MessagingTriviaResultsResponses);
